import type { Category } from '@dutchiesdk/ecommerce-extensions-sdk';

import type { Dispensaries } from 'src/gql/graphql';
import type { DispensaryMenuCategory } from 'src/dispensary/hooks/use-dispensary-categories';
import { buildCategoryRoute } from 'shared/helpers/route-helpers';

type CategoryRouteContext = {
  isDemo: boolean;
  isEmbedded: boolean;
  isKiosk: boolean;
  isMobileEcommApp: boolean;
  isStoreFront: boolean;
  dispensary?: Dispensaries;
};

export function createMapCategoryToRemote({
  isDemo,
  isKiosk,
  isEmbedded,
  isStoreFront,
  isMobileEcommApp,
  dispensary,
}: CategoryRouteContext): (category: DispensaryMenuCategory) => Category & { href: string; route: string } {
  return (category) => {
    const [href, route] = buildCategoryRoute({
      isDemo,
      isKiosk,
      isEmbedded,
      isStoreFront,
      isMobileEcommApp,
      dispensary,
      category: category.key,
    });

    return {
      cname: category.slug ?? category.key,
      href,
      id: category.key,
      image: category.cardImage,
      isOutlet: category.isOutlet,
      name: category.label,
      route,
    };
  };
}
